export default function normalizeSiteCodeAcl(value) {
  if (typeof value !== "string") return "";
  return value.trim().toUpperCase();
}
